import { createApi } from '@reduxjs/toolkit/query/react';
import type {
  PlanCreateRequest,
  PlanResponse,
  PlanStatsResponse,
  PlanWithProgress,
} from '@/generated/types/navigator/types.gen';
import { baseQueryWithAuth } from './utils';

export const projectApi = createApi({
  reducerPath: 'projectApi',
  baseQuery: baseQueryWithAuth,
  tagTypes: ['project'],
  endpoints: (builder) => ({
    listProjects: builder.query<PlanWithProgress[], void>({
      query: () => '/v1/projects/',
      providesTags: ['project'],
    }),
    getProject: builder.query<PlanWithProgress, string>({
      query: (projectId) => `/v1/projects/${projectId}`,
      providesTags: (_result, _error, projectId) => [
        { type: 'project', id: projectId },
      ],
    }),
    getProjectMetrics: builder.query<PlanStatsResponse, { scopeQuery: string }>(
      {
        query: ({ scopeQuery }) => ({
          url: '/v1/projects/metrics',
          params: { scope_query: scopeQuery },
        }),
      }
    ),
    createProject: builder.mutation<PlanResponse, PlanCreateRequest>({
      query: (body) => ({
        url: '/v1/projects/',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['project'],
    }),
  }),
});

export const resetProjectApiState = projectApi.util.resetApiState;

export const {
  useListProjectsQuery,
  useGetProjectQuery,
  useGetProjectMetricsQuery,
  useCreateProjectMutation,
} = projectApi;
